import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Observable';
import {ISocketService} from 'app/+common/contracts/socket.service.contract';


@Injectable()
export class SocketService implements ISocketService {
    private socket: WebSocket;

    private _tagsList: Array<string> = [];
    private _lastReadTime: Date = null;

    private tickIntervalHandler;
    private readonly INTERVAL = 15000;

    private updateTagList = null;
    private _tagListObservable: Observable<Array<string>> =
        new Observable<Array<string>>((obs) => this.updateTagList = obs);

    private updateAntennaReadStatus;
    private _antennaStatusReadObservable: Observable<boolean> =
        new Observable<boolean>((obs) => this.updateAntennaReadStatus = obs);

    private sendPing() {
        if (!this.socket) {
            return;
        }
        console.log('Send Ping');
        try {
            this.socket.send(JSON.stringify({type: 'PING', payload: {}}));
        } catch (e) {
            console.log('Error while sending ping');
        }
    }

    private onMessage(evt) {
        const dataObject = JSON.parse(evt.data);
        console.log('Message Received', dataObject);

        if (dataObject.type === 'PONG') {
            return;
        } else if (dataObject.type === 'TAG_READ') {
            //console.log('Tag read number:', dataObject.payload.totalRead);

            const tags = dataObject.payload.tags;
            this._tagsList.push(...tags);
            const set = new Set(this._tagsList);

            this._tagsList = Array.from(set);
            this._lastReadTime = dataObject.payload.date;

            this.updateTagList.next(this.tags);
        } else if (dataObject.type === 'ERROR_READ') {
            console.log('Error while Reading Tag from Antenna');
        } else if (dataObject.type === 'STARTED') {
            console.log('Antenna Reading Started');
            this.updateAntennaReadStatus.next(true);
        } else if (dataObject.type === 'ERROR_STARTED') {
            console.log('Antenna Start Error');
            this.updateAntennaReadStatus.next(false);
            this.stopRead();
            //setTimeout(()=>  this.startRead(), 2000);
        }
    }

    private onError(err) {
        console.log('ERROR WEBSOCKET', err);
        try {
            this.updateAntennaReadStatus.next(false);

        } catch (e) {
        }
    }

    public initSocket(host: string, port: number): Observable<boolean> {
        if (this.socket) {
            this.socket.close();
            this.socket=null;
        }
        let updateOpenSocketResult;
        const openObservables = new Observable<boolean>((obs) => updateOpenSocketResult = obs);

        this.socket = new WebSocket(`ws://${host}:${port}`);

        this.socket.onopen = () => {
            console.log('Socket Connection opened');

            updateOpenSocketResult.next(true);
            updateOpenSocketResult.complete();

            this.updateAntennaReadStatus.next(true);

            this.tickIntervalHandler = setInterval(() => {
                this.sendPing();
            }, this.INTERVAL);
        };

        this.socket.onclose = (e) => {
            console.log(`Socket Connection closed ${e.code}`);
            this.updateAntennaReadStatus.next(false);
            this.socket = null;
            clearInterval(this.tickIntervalHandler);
        };

        this.socket.onmessage = (evt) => {
            this.onMessage(evt);
        };

        this.socket.onerror = (err) => {
            this.onError(err);
            updateOpenSocketResult.next(false);
            updateOpenSocketResult.complete();
        };

        return openObservables;
    }

    public startRead() {
        console.log('Start Read');
        if (this.socket) {
            this.socket.send(JSON.stringify({type: 'START_READ'}));
        }
    }

    public stopRead() {
        console.log('End Read');
        if (this.socket) {
            this.socket.send(JSON.stringify({type: 'STOP_READ'}));
            this.updateAntennaReadStatus.next(false);
        }
    }

    get onUpdateTags(): Observable<Array<string>> {
        return this._tagListObservable;
    }

    get onStatusChange(): Observable<boolean> {
        return this._antennaStatusReadObservable;
    }

    get tags(): Array<string> {
        //console.log('this._tagsList', this._tagsList);

        const replaceAll = (string, search, replacement) => {
            return string.replace(new RegExp(search, 'g'), replacement);
        };

        return this._tagsList.map(item => {
            //console.log('item', item);
            const i = replaceAll(item, '-', '');
            //console.log('i', i);
            return i;
        });
    }


    get lastReadTime(): Date {
        return this._lastReadTime;
    }

    public clearTags() {
        this._tagsList = [];
        this._lastReadTime = null;
    }

    public close(): void {
        if (this.socket) {
            this.socket.close();
        }
        clearInterval(this.tickIntervalHandler);
    }

}



// WEBPACK FOOTER //
// ./src/app/+common/services/socket.service.ts